export const allocationsGridModes = {
    daily: "daily",
    weekly: "weekly",
    monthly: "monthly",
};

export const formModes = {
    ADD: 0,
    ADDED: 1,
    UPDATE: 2,
    UPDATED: 3,
    DELETE: 4,
    DELETED: 5,
    DETAIL: 6,
};

export const customFilterTypes = {
    ALLOCATION: "Allocations",
};

export const batchOperation = {
    add: "add",
    remove: "remove",
};

export const saveHoursConfirmation = {
    deleteNoteForZeroAllocation: 0,
    addHoursToZeroAvailable: 1,
};

export const EDGES = {
    TOP: "top",
    BOTTOM: "bottom",
    LEFT: "left",
    RIGHT: "right",
};
